// assets
import { DashboardOutlined } from '@ant-design/icons';
import { NavGroupType } from './types';

// icons
const icons = {
    DashboardOutlined,
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const dashboard: NavGroupType = {
    id: 'group-dashboard',
    title: 'menu.general.title',
    type: 'group',
    children: {
        dashboard: {
            id: 'dashboard',
            title: 'menu.general.items.dashboard',
            type: 'item',
            url: '/',
            icon: icons.DashboardOutlined,
            breadcrumbs: false,
        },
    },
};

export default dashboard;
